/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Mojo STG environment overrides.
 *
 * @author Vignesh Selvam
 */

const mojoStg = {
    CLIENT_ID: 'jbxnqvJw6NJEMzJLBQbMSVWpgrZUUC0g',
    SSI_CLIENT_ID: 'I3l3CiMiPkq8LpGSK9IMRcHBJlSQKhYH',
    TENANT_KEY_ETEXT: 'daa92f39-9a75-4c2a-abaf-2269d70f7422',
    TENANT_KEY_ETEXT_PDF: 'daa92f39-9a75-4c2a-abaf-2269d70f7422',
};

module.exports = mojoStg;
